module.exports = __webpack_public_path__ + "static/img/chain-org-num.08f013d6.png";